export const API_KEY = "AIzaSyA-hyUdUTZYc_Pcw_3oDAaZYqMmzxpgo7s";
export const RAIZ = "https://servicetracking-1091.firebaseio.com/";
export const SERVICIOS_URL = RAIZ + "servicios.json";
export const SERVICIO_URL  = RAIZ + "servicios/";
export const USERS_URL     = RAIZ + "users/";
export const REGISTRO_URL  = RAIZ + "registro/";
export const UBICACION_URL = RAIZ + "ubicacion/";
export const NOTIFY_URL    = RAIZ + "notificaciones";
export const BASE_MAPS     = "https://maps.googleapis.com/maps/api";
export const GEOCODE       = "https://maps.googleapis.com/maps/api/geocode/json?latlng=";

//AIzaSyDSrrDvAnAIkYlTCi7tMVNfOrZKrxtziHQ
//AIzaSyDwof6qF-Oq_Cc9m-sj6iL4pm0kFSD601w  <-- ACFINDER



// WEBPACK FOOTER //
// C:/xampp/htdocs/service_tracking/web/service_tracking/src/app/components/Config/globals.config.ts